var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.433,
    height: 30.238,
    viewBox: "0 0 31.433 30.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5588",
    "data-name": "Group 5588",
    transform: "translate(-590.534 -45.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5216",
    "data-name": "Path 5216",
    d: "M3.351,0A3.351,3.351,0,1,1,0,3.351,3.351,3.351,0,0,1,3.351,0Z",
    transform: "translate(590.724 45.011)",
    fill: "#ef1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5213",
    "data-name": "Path 5213",
    d: "M913.262,33.077h0a3.541,3.541,0,0,1,3.541,3.541V55.525h-7.081V36.618a3.541,3.541,0,0,1,3.541-3.541Z",
    transform: "translate(-319.187 19.724)",
    fill: "#ef1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5214",
    "data-name": "Path 5214",
    d: "M913.262,33.077h0a3.534,3.534,0,0,1,3.541,3.528v26.71h-7.081V36.605a3.535,3.535,0,0,1,3.541-3.528Z",
    transform: "translate(-307.106 11.934)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5215",
    "data-name": "Path 5215",
    d: "M913.262,33.077h0a3.534,3.534,0,0,1,3.541,3.528v26.71h-7.081V36.605a3.535,3.535,0,0,1,3.541-3.528Z",
    transform: "translate(-294.835 11.934)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpen);
export default __webpack_public_path__ + "static/media/menu-open.aafca0fdef60f70d0bbb629d77a3f529.svg";
export { ForwardRef as ReactComponent };